export const SET_COMIC_STATUS_REQUEST = "SET_COMIC_STATUS_REQUEST";
export const SET_COMIC_STATUS_SUCCESS = "SET_COMIC_STATUS_SUCCESS";
export const SET_COMIC_STATUS_FAIL = "SET_COMIC_STATUS_FAIL";

export const DELETE_COMIC_REQUEST = "DELETE_COMIC_REQUEST";
export const DELETE_COMIC_SUCCESS = "DELETE_COMIC_SUCCESS";
export const DELETE_COMIC_FAIL = "DELETE_COMIC_FAIL";

